import {Component, Input, OnInit} from '@angular/core';
import {Tractor} from 'shared';

@Component({
  selector: 'app-map-tractor-popup',
  templateUrl: './map-tractor-popup.component.html',
  styleUrls: ['./map-tractor-popup.component.scss']
})
export class MapTractorPopupComponent implements OnInit {
  private _tractor: Tractor;

  @Input()
  set tractor(value: Tractor) {
    this._tractor = value;
    const nextParams = value && value.tracker && value.tracker.params
      ? Object.keys(value.tracker.params).sort()
      : [];
    // Preserve the array when keys are unchanged so dx-scroll-view retains
    // its position while live values refresh.
    if (!this.params || this.params.join('\\0') !== nextParams.join('\\0')) {
      this.params = nextParams;
    }
  }

  get tractor(): Tractor {
    return this._tractor;
  }
  selectedIndex = 0;
  params: string[];
  tabs = [
    {text: 'Inforamtion'},
    {text: 'Vitesse'},
    {text: 'Détails'},
  ];

  constructor() {
  }

  ngOnInit(): void {
    this.params = this.tractor && this.tractor.tracker && this.tractor.tracker.params
      ? Object.keys(this.tractor.tracker.params).sort()
      : [];
  }

  trackParam(index: number, name: string): string {
    return name;
  }

  selectTab(e: any) {

  }
}
